import { useContext, useEffect, useRef, useState } from "react";
import { chooseFileIcon, closeIcon } from "../../../assets/icons";
import styles from "./newAdPartOne.module.css";
import { fetchSuppliers, fetchCompanyGroups } from "../../../Api/Services/Suppliers";
import { SuppliersModel } from "../../../Models/SuppliersModel";
import { WizardContext } from "../../../Store/Wizard.store";
import InfoPopup from "../../InfoPopup";

export default function NewAdPartOne() {
  const WriteRadio = "write";
  const SelectRadio = "select";
  const {wizardFormData, setWizardFormData} = useContext(WizardContext);
  const [nameError, setnameError] = useState(false);
  const [emailError, setemailError] = useState(false);
  const [companyError, setcompanyError] = useState(false);
  const [logoError, setlogoError] = useState(false);
  const [logoFileText, setlogoFileText] = useState("Choose file");
  const [suppliers, setSuppliers] = useState<SuppliersModel[]>([]);
  const [suppliersTypeAhead, setSuppliersTypeAhead] = useState<SuppliersModel[]>([]);
  const [companyGroups, setCompanyGroups] = useState<SuppliersModel[]>([]);
  const [companyGroupsTypeAhead, setCompanyGroupsTypeAhead] = useState<SuppliersModel[]>([]);
  const [companyNameAlternative, setCompanyNameAlternative] = useState(WriteRadio);
  const [disableLogo, setDisableLogo] = useState(wizardFormData.editMode && wizardFormData.adData.logotype.fileName != "" ? true : false);
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const companyRef = useRef<HTMLInputElement>(null);
  const logoRef = useRef<HTMLInputElement>(null);
  const h2Ref = useRef<HTMLHeadingElement>(null);
  const companyGroupRef = useRef<HTMLInputElement>(null);


  useEffect(() => {
    getSupliers();
    getCompanyGroups();
    if (h2Ref.current && wizardFormData.initialSetup == false) {
      h2Ref.current.scrollIntoView();
    }
    if (wizardFormData.initialSetup){
      setWizardFormData({...wizardFormData, initialSetup: false});
    }
  }, []);

  const getSupliers = () => {
    fetchSuppliers().then((data) => {
      setSuppliers(data);
    });
  };

  const getCompanyGroups = () => {
    fetchCompanyGroups().then((data) => {
      setCompanyGroups(data);
    });
  };

  const updateCompanyGroupsTypeAhead = (
    event: React.ChangeEvent<HTMLInputElement> | null
  ) => {
    if (event != null) {
      if (event.target.value.length > 1) {
        setCompanyGroupsTypeAhead(
          companyGroups.filter((company) =>
            company.name
              .toLowerCase()
              .startsWith(event.target.value.toLowerCase())
          )
        );
      }
    } else {
      setCompanyGroupsTypeAhead([]);
    }
  };

  const updateSupliersTypeAhead = (
    event: React.ChangeEvent<HTMLInputElement> | null
  ) => {
    if (event != null) {
      if (event.target.value.length > 1) {
        setSuppliersTypeAhead(
          suppliers.filter((company) =>
            company.name
              .toLowerCase()
              .includes(event.target.value.toLowerCase())
          )
        );
      }
    } else {
      setSuppliersTypeAhead([]);
    }
  };

  const updateLogoFileText = async () => {
    if (logoRef.current?.files && logoRef.current.files.length > 0) {
      setlogoFileText(logoRef.current.files[0].name);
      setWizardFormData({
        ...wizardFormData,
        adData: {
          ...wizardFormData.adData,
          logotype: {
            fileData: logoRef.current.files[0],
            fileName: logoRef.current.files[0].name,
            mimeType: "",
            id: 0,
          }
        },
      });
    } else {
      setlogoFileText("Choose file");
    }
  };

  const toggleCompanyNameAlternative = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCompanyNameAlternative(event.target.value);
    companyGroupRef.current != null ? companyGroupRef.current.value = "" : "";
    setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, companyName: "" } });
    setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, companyGroupId: undefined } });
  };

  const validateFields = () => {
    let continueSubmit = true;
    if (nameRef.current?.value === "") {
      setnameError(true);
      continueSubmit = false;
    }
    if (
      emailRef.current?.value === "" ||
      !emailRef.current?.value.includes("@")
    ) {
      setemailError(true);
      continueSubmit = false;
    }
    if (companyNameAlternative === WriteRadio && wizardFormData.adData.companyName === "") {
      setcompanyError(true);
      continueSubmit = false;
    }
    if (companyNameAlternative === SelectRadio && wizardFormData.adData.companyGroupId === undefined) {
      setcompanyError(true);
      continueSubmit = false;
    }
    if (wizardFormData.editMode == false && logoRef.current?.value === "") {
      setlogoError(true);
      continueSubmit = false;
    }

    // Focus the first element with the class "error"
    const firstErrorElement = document.querySelector(".error");
    if (firstErrorElement) {
      (firstErrorElement as HTMLElement).focus();
    }

    if (continueSubmit) {
      setWizardFormData({...wizardFormData, wizardStep: 2});
    }
  };


  const updateContext = (event: React.ChangeEvent<HTMLInputElement>) => {
    setWizardFormData({
      ...wizardFormData,
      adData: {
        ...wizardFormData.adData,
        [event.target.name]: event.target.value,
      },
    });
  };

  const removeExistingLogotype = () => {
        setWizardFormData({...wizardFormData, adData: {...wizardFormData.adData, logotype: {fileData: new File([""], ""), fileName: "", mimeType: "", id: 0}}});
        setDisableLogo(false);
  };

  return (
    <div>
        <h2 ref={h2Ref}>Contact information</h2>
        <div className={styles.content}>
          <div>
            <div className={styles.input_container}>
              <label htmlFor="contactName">Contact name *</label>
              <InfoPopup content="Your name or other contact person." />
              <span>(Won't be shown in your ad)</span>
              <input
                ref={nameRef}
                type="text"
                name="contactName"
                id="contactName"
                placeholder="Your name"
                required
                className={nameError ? "error" : ""}
                value={wizardFormData.adData.contactName}
                onChange={(e) => {setnameError(false); setWizardFormData({...wizardFormData, adData: {...wizardFormData.adData, contactName: e.target.value}});}}
                onBlur={updateContext}
              />
            </div>
            <div className={styles.input_container}>
              <label htmlFor="contactEmail">Contact email *</label>
              <InfoPopup content="The email address potential buyers can use for inquiries about your product." />
              <span>(Won't be shown in your ad)</span>
              <input
                ref={emailRef}
                type="text"
                name="contactEmail"
                id="contactEmail"
                placeholder="Your email adress"
                required
                className={emailError ? "error" : ""}
                value={wizardFormData.adData.contactEmail}
                onChange={(e) => {setemailError(false); setWizardFormData({...wizardFormData, adData: {...wizardFormData.adData, contactEmail: e.target.value}});}}
                onBlur={updateContext}
              />
            </div>
          </div>
          <div>
            <div className={styles.input_container}>
              <label htmlFor="companyName">Company name *</label>
              <InfoPopup content="The name of your company." />
              <div className={styles.ml3}>
                <input
                  type="radio"
                  name="companyNameAlternative"
                  id="writeCompany"
                  value={WriteRadio}
                  onChange={toggleCompanyNameAlternative}
                  checked={companyNameAlternative == WriteRadio}
                />
                <div className={styles.company_name_text_container}>
                  <input
                    ref={companyRef}
                    type="text"
                    name="companyName"
                    id="companyName"
                    placeholder="Your company name"
                    autoComplete="off"
                    required
                    className={
                      companyError && companyNameAlternative == WriteRadio
                        ? "error"
                        : ""
                    }
                    disabled={companyNameAlternative != WriteRadio}
                    value={wizardFormData.adData.companyName}
                    onChange={(e) => {
                      setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, companyName: e.target.value } });
                      setcompanyError(false);
                      updateSupliersTypeAhead(e);
                    }}
                    onBlur={updateContext}
                  />
                  <div className={styles.typeahead}>
                    {suppliersTypeAhead.map((company, key) => {
                      return (
                        <button
                          key={key}
                          type="button"
                          className={styles.typeahead_choice}
                          onClick={(e: any) => {
                            updateSupliersTypeAhead(null);
                            setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, companyName: e.target.innerText } });
                          }}
                        >
                          {company.name}
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className={styles.ml3}>
                <input
                  type="radio"
                  name="companyNameAlternative"
                  id="slectCompany"
                  value={SelectRadio}
                  checked={companyNameAlternative == SelectRadio}
                  onChange={toggleCompanyNameAlternative}
                />
                <div className={styles.company_name_text_container}>
                  <input
                    ref={companyGroupRef}
                    name="companyGroup"
                    id="companyGroup"
                    type="text"
                    disabled={companyNameAlternative != SelectRadio}
                    placeholder="Or select company group"
                    autoComplete="off"
                    onChange={(e) => {
                      setcompanyError(false);
                      updateCompanyGroupsTypeAhead(e);
                    }}
                    className={
                      companyError && companyNameAlternative == SelectRadio
                        ? "error"
                        : ""
                    }
                  />
                  <div className={styles.typeahead}>
                    {companyGroupsTypeAhead.map((supplier, key) => {
                      return (
                        <button
                          key={key}
                          type="button"
                          value={supplier.id}
                          className={styles.typeahead_choice}
                          onClick={() => {
                            updateCompanyGroupsTypeAhead(null);
                            companyGroupRef.current != null ? companyGroupRef.current.value = supplier.name : "";
                            setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, companyGroupId: supplier.id } });
                          }}
                        >
                          {supplier.name}
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.input_container}>
              <label htmlFor="companyWebsite">Company website</label>
              <InfoPopup content="Address to the company website." />
              <input
                type="text"
                name="companyWebsite"
                id="companyWebsite"
                placeholder="www.yourcompanywebsite.com"
                required
                value={wizardFormData.adData.companyWebsite}
                onChange={(e) => setWizardFormData({...wizardFormData, adData: {...wizardFormData.adData, companyWebsite: e.target.value}})}
                onBlur={updateContext}
              />
            </div>
          </div>
          <div className={`${styles.input_container} ${styles.files}`}>
            <label htmlFor="companyLogotype">Company logotype {wizardFormData.editMode ? "" : "*"}</label>
            <InfoPopup content="This image will be displayed next to your ad. Maximum size 800 X 800 px." />
            {wizardFormData.editMode && wizardFormData.adData.logotype.fileName != ""? 
              <div>
                <span className={styles.existing_file}>{wizardFormData.adData.logotype.fileName}
                  <button type="button" onClick={() => removeExistingLogotype()}>{closeIcon}</button>
                </span> 
              </div> : 
              ""
            }
            <input
              ref={logoRef}
              type="file"
              name="companyLogotype"
              id="companyLogotype"
              accept="image/png, image/jpeg"
              placeholder="Your phone number"
              required={!wizardFormData.editMode}
              onChange={() => {
                updateLogoFileText();
                setlogoError(false);
              }}
            />
            <div className={`${logoError ? "error" : ""} ${styles.upload_container}`}>
              <i>{chooseFileIcon}</i>
              <button className={disableLogo ? styles.disabled : ""} disabled={disableLogo} type="button" onClick={() => logoRef.current?.click()}>
                {logoFileText}
              </button>
            </div>
            <span>Allowed image formats: JPG, PNG</span>
          </div>
        </div>
        <button
          type="button"
          className={`button button_black ${styles.next}`}
          onClick={validateFields}
        >{wizardFormData.editMode ? "Next: Modify your ad" : "Next: Create your ad"}</button>
    </div>
  );
}
